export default "__VITE_ASSET__b9dc7066__"